module.exports = __webpack_public_path__ + "a17c8c70cb5d993f4d222227968c21ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/throne-s.png
// module id = 1403
// module chunks = 0